module.exports = __webpack_public_path__ + "static/media/avatar.dde2ce95.png";